import { useQuery } from 'react-query';

import type { OrganizationJobDetails } from '../types';

type UseJobDetailsHandler = {
  data: OrganizationJobDetails;
  error: string | null;
  isLoading: boolean;
};
const useJobDetails = (jobId: number): UseJobDetailsHandler => {
  const { isLoading, error, data } = useQuery<OrganizationJobDetails, string>(
    'job-details',
    async () => {
      const response = await fetch(`/api/organisation/jobs/${jobId}/details/`);
      if (response.ok) return response.json();
      throw new Error('Something went wrong');
    },
  );
  return { data: data ?? ({} as OrganizationJobDetails), error, isLoading };
};

export default useJobDetails;
